<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'File'
}
</script>

<style>

</style>
